import { useCallback } from 'react';
import { Input } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { jsx } from '@emotion/react/jsx-runtime';

const DimensionField = _ref => {
  let {
    type,
    name,
    errors,
    values,
    touched,
    onBlur,
    onChange
  } = _ref;
  const {
    t
  } = useTranslation();
  const onInputChange = useCallback(e => {
    const targetValue = e.target.value;
    const matchResult = targetValue.toString().match(/\d+/g);
    e.target.value = matchResult ? matchResult.join('') : '';
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange]);
  return jsx(Input, {
    name: `${name}.${type}`,
    label: t(`parcel-field.label.${type}`),
    "data-id": `${name}.${type}`,
    value: values[type],
    isInvalid: !!(errors !== null && errors !== void 0 && errors[type]) && !!(touched !== null && touched !== void 0 && touched[type]),
    onBlur: onBlur,
    inputMode: "decimal",
    onChange: onInputChange,
    rightContent: "cm",
    autoComplete: "off"
  });
};

export { DimensionField };
//# sourceMappingURL=DimensionField.js.map
